import { render, staticRenderFns } from "./FormCreateMateria.vue?vue&type=template&id=e0a69608&"
import script from "./FormCreateMateria.vue?vue&type=script&lang=js&"
export * from "./FormCreateMateria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports